// @flow
import React from 'react';
import classnames from 'classnames';
import stylesheet from './AvailabilityStatus.scss';
import { formatDateWithYear } from 'utils/FormatData/FormatData';

type StatusType = $Keys<typeof statusTypes>;

type Props = {|
  status: StatusType,
|};

const AvailabilityStatus = ({ status, dateAvailable }: Props) => {
  const unavailableStatusType = dateAvailable
    ? 'unavailable-until'
    : 'unavailable';

  const statusTypes = {
    // MM availability statuses
    CURRENTLY_AVAILABLE: 'currently-available',
    FULL_TIME_AVAILABLE: 'full-time-available',
    PART_TIME_AVAILABLE: 'part-time-available',
    // Earthlings availability statuses
    AVAILABLE_IMMEDIATELY: 'available',
    OPEN_TO_OFFERS: 'open',
    // Status in both MM and Earthlings
    UNAVAILABLE: unavailableStatusType,
  };

  const availabilityClass = classnames(
    stylesheet.availability,
    stylesheet[`availability--${statusTypes[status]}`]
  );

  const unavailableMessage = dateAvailable
    ? `Available from ${formatDateWithYear(dateAvailable)}`
    : 'Unavailable';

  const availabilityMessages = {
    // MM availability statuses
    CURRENTLY_AVAILABLE: 'Currently Available',
    FULL_TIME_AVAILABLE: 'Available Full Time',
    PART_TIME_AVAILABLE: 'Available Part Time',
    // Earthlings availability statuses
    AVAILABLE_IMMEDIATELY: 'Available',
    OPEN_TO_OFFERS: 'Open to Offers',
    // Status in both MM and Earthlings
    UNAVAILABLE: unavailableMessage,
  };

  const availabilityMessage = availabilityMessages[status];

  return <span className={availabilityClass}>{availabilityMessage}</span>;
};

export default AvailabilityStatus;
